import { useEffect, useState } from 'react';
import { fetchSettings } from '@/api';

export function useCurrencySymbol(defaultSymbol: string = '$') {
  const [currencySymbol, setCurrencySymbol] = useState<string>(defaultSymbol);

  useEffect(() => {
    let mounted = true;
    fetchSettings()
      .then((res) => {
        const symbol = res?.data?.currency_symbol || res?.data?.data?.currency_symbol;
        if (mounted && symbol) setCurrencySymbol(symbol);
      })
      .catch(() => {
        // keep default on failure
      });
    return () => { mounted = false; };
  }, []);

  return currencySymbol;
}

